import Vue from 'vue'

function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
}


//返回
Vue.prototype.goBack = _=>{
	var that = this;
	window.history.go(-1);
}

//时间格式化+0
Vue.prototype.formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}


//YY.MM.DD
Vue.prototype.formatTime = value => {
	var date = new Date(value * 1);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return [ year,month,day].map(formatNumber).join('.');
};


Vue.prototype.myAlert = value => {
	let $body = document.querySelector('body');
	let $alertWrap = document.createElement('div');
	$alertWrap.innerHTML = "你看啥子玩意儿";
	$alertWrap.classList.add('alertWrap');
	$body.appendChild($alertWrap)
};



// WEBPACK FOOTER //
// ./src/assets/js/prototype.js